import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fallbackError", "prefix", "type", "error"];
import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { SSO_KNOWLEDGE_BASE_DOCUMENT } from '../../constants/KnowledgeBaseUrls';
import { NO_RECORD_ERROR, SAML_ERROR, TWO_FACTOR_NAMETAG_FAILED } from '../../constants/ErrorValues';
import TwoFactorAuthStatuses from '../../constants/TwoFactorAuthStatuses';
import { jsx as _jsx } from "react/jsx-runtime";
const errorMessageProps = {
  [NO_RECORD_ERROR]: props => ({
    message: 'login.errors.NO_RECORD.body_jsx',
    options: {
      href: props && props.signUpLink
    },
    elements: {
      Link
    }
  }),
  [TWO_FACTOR_NAMETAG_FAILED]: props => ({
    message: 'login.errors.TWO_FACTOR_NAMETAG_FAILED.body_jsx',
    options: {
      use: 'link',
      onClick: props && props.details && props.details.onPrevPage
    },
    elements: {
      Button
    }
  }),
  [SAML_ERROR]: () => ({
    options: {
      knowledgeBaseButton: /*#__PURE__*/_jsx(KnowledgeBaseButton, {
        url: SSO_KNOWLEDGE_BASE_DOCUMENT
      })
    }
  }),
  [TwoFactorAuthStatuses.DEACTIVATED_USER]: props => ({
    message: props !== null && props !== void 0 && props.vettingUrl ? 'login.errors.DEACTIVATED_USER.vetting_body_jsx' : 'login.errors.DEACTIVATED_USER.body',
    options: {
      href: props && props.vettingUrl
    },
    elements: {
      Link
    }
  })
};
const ErrorMessage = _ref => {
  let {
      fallbackError = 'LOGIN_UNAVAILABLE',
      prefix = 'login.errors',
      type = 'danger',
      error
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const props = Object.assign({
    fallbackError,
    prefix,
    type,
    error
  }, rest);
  const errorMessageComponents = {
    [NO_RECORD_ERROR]: FormattedJSXMessage,
    [TWO_FACTOR_NAMETAG_FAILED]: FormattedJSXMessage,
    [SAML_ERROR]: FormattedReactMessage,
    [TwoFactorAuthStatuses.DEACTIVATED_USER]: props.vettingUrl ? FormattedJSXMessage : FormattedHTMLMessage
  };
  if (!error) {
    return /*#__PURE__*/_jsx("div", {});
  }
  let i18nKey = `${prefix}.${error}`;
  if (!isValidI18nKey(`${i18nKey}.title`)) {
    i18nKey = `${prefix}.${fallbackError}`;
  }
  const options = props.details ? props.details : {};
  const ErrorMessageComponent = errorMessageComponents[error] || FormattedHTMLMessage;
  const messageProps = Object.assign({
    message: `${i18nKey}.body`
  }, errorMessageProps[error] ? errorMessageProps[error](props) : {
    options
  });
  return /*#__PURE__*/_jsx(Alert, {
    "data-error-type": error,
    "data-test-id": `error-alert-${error}`,
    titleText: I18n.text(`${i18nKey}.title`),
    type: type,
    marginBlockEnd: "400",
    use: "inline",
    children: /*#__PURE__*/_jsx(Text, {
      textAlign: "start",
      children: /*#__PURE__*/_jsx(ErrorMessageComponent, Object.assign({}, messageProps))
    })
  });
};
export default ErrorMessage;